export enum NumberFormat {
  PRICE = 'price',
  PERCENTAGE = 'percentage',
  NUMBER = 'number',
}
